import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Col from "@bappweb/col"
import Row from "@bappweb/row"
import "../assets/style.scss"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Row>
        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
          <div className="bapp-container">
            <Block className="landing-header-text-wrapper">
              <Block className="landing-header-text">
                <Element type="h2" className="header-text1">
                  {
                    "Bireysel Emeklilik Başvuru Formunu şimdi doldurun %20 devlet katkılı BES'ten Akbank farkıyla hemen yararlanmaya başlayın."
                  }
                </Element>
                <Element type="p" className="header-text2">
                  {
                    "Bireysel emeklilik sistemi ile geleceğiniz için düzenli birikim yaparken geniş fon seçenekleri ve uzman portföy yöneticileri tarafından sunulan fon dağılım önerileri ile yatırımlarınızı büyütebilirsiniz!"
                  }
                </Element>
              </Block>
            </Block>
          
          <Image path={"./img/beslead/bes-basvuru.png"} className="landing-header-img" />
          </div>
        </Col>
      </Row>
    </Block>
  )
}

export default LandingHeader
